import React from 'react';
import { Button, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FiSave, FiEdit3, FiTrash2 } from 'react-icons/fi';
import { IoPeople } from 'react-icons/io5';
import SimilarEntityAlert from './SimilarEntityAlert';
import MeterTable from './MeterTable';

const EntityCard = ({
  entityGroup,
  groupIndex,
  similarMatch,
  isEntitySaving,
  error,
  editingMeters,
  onSaveEntity,
  onDeleteEntity,
  onEditEntity,
  onKeepExisting,
  onUseNew,
  onAssignParent,
  parentName,
  showAssignParent,
  onEdit,
  onSaveMeterEdit,
  onCancelEdit,
  onDeleteClick,
  onFieldChange
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">
          {entityGroup.entityName}
          {error && <span className="ml-2 badge badge-danger">{t('Error')}</span>}
        </h5>
        <div>
          <Button
            variant="dark"
            size="sm"
            className="mr-2"
            onClick={() => onSaveEntity(groupIndex, entityGroup.entityName)}
            disabled={isEntitySaving || similarMatch?.loading}
          >
            {isEntitySaving ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" style={{ verticalAlign: 'middle' }} />
                {t('Saving...')}
              </>
            ) : similarMatch?.loading ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" style={{ verticalAlign: 'middle' }} />
                {t('Checking...')}
              </>
            ) : (
              <>
                <FiSave className="mr-2" style={{ verticalAlign: 'middle' }} />
                {t('Save')}
              </>
            )}
          </Button>
          {showAssignParent && (
            <Button
              variant="outline-dark"
              size="sm"
              className="mr-2"
              onClick={() => onAssignParent(entityGroup.entityName)}
              disabled={isEntitySaving}
            >
              <IoPeople className="mr-2" style={{ verticalAlign: 'middle' }} />
              {t('Assign Parent')}
            </Button>
          )}
          <Button
            variant="outline-danger"
            size="sm"
            onClick={() => onDeleteEntity(groupIndex)}
            disabled={isEntitySaving}
          >
            <FiTrash2 className="mr-2" style={{ verticalAlign: 'middle' }} />
            {t('Delete')}
          </Button>
        </div>
      </div>

      <SimilarEntityAlert
        similarMatch={similarMatch}
        entityName={entityGroup.entityName}
        onKeepExisting={onKeepExisting}
        onUseNew={onUseNew}
      />

      <div className="mb-2 d-flex justify-content-between align-items-center">
        <div>
          <div>
            <strong>{t('Entity Name')}:</strong> {entityGroup.entityName}
          </div>
          <small className="text-muted">
            {parentName ? (
              <>
                <strong>{t('Parent')}:</strong> {parentName}
              </>
            ) : (
              t('No parent assigned')
            )}
          </small>
        </div>
        <Button
          variant="link"
          size="sm"
          className="p-0"
          onClick={() => onEditEntity(groupIndex)}
          title={t('Edit Entity')}
        >
          <FiEdit3 size={18} />
        </Button>
      </div>

      <h6 className="mt-3 mb-2">{t('Meters')}</h6>

      <MeterTable
        meters={entityGroup.meters}
        groupIndex={groupIndex}
        editingMeters={editingMeters}
        onEdit={onEdit}
        onSaveMeterEdit={onSaveMeterEdit}
        onCancelEdit={onCancelEdit}
        onDeleteClick={onDeleteClick}
        onFieldChange={onFieldChange}
      />

      {error && (
        <Alert variant="danger" className="mt-3">
          <strong>{t('Validation Error')}:</strong> {error}
        </Alert>
      )}
    </div>
  );
};

export default EntityCard;
